var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.6 10.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8,0.3L5.3,3.8L1.8,0.3l0,0c-0.4-0.4-1.1-0.4-1.5,0s-0.4,1.1,0,1.5l0,0l3.5,3.5L0.3,8.8c-0.4,0.4-0.4,1.1,0,1.5 c0.4,0.4,1.1,0.4,1.5,0l3.5-3.5l3.5,3.5c0.4,0.4,1.1,0.4,1.5,0s0.4-1.1,0-1.5L6.8,5.3l3.5-3.5c0.4-0.4,0.4-1.1,0-1.5 C9.9-0.1,9.2-0.1,8.8,0.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.2b26444bd72d8f1cc011532bc913d0f8.svg";
export { ForwardRef as ReactComponent };